import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  return <AnimatePresence data-id="element-226">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[60] pointer-events-none" data-id="element-227" />
          <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-id="element-228">
            <div className="absolute inset-0" onClick={onClose} data-id="element-229" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-[#0a0a0a] border border-white/10 rounded-2xl max-w-4xl w-full max-h-[85vh] overflow-hidden shadow-2xl relative z-10" data-id="element-230">
              <div className="sticky top-0 bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/10 px-6 py-4 flex items-center justify-between" data-id="element-231">
                <h2 className="text-2xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-232">
                  Términos y Condiciones de Uso
                </h2>
                <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 transition-colors" data-id="element-233">
                  <XIcon className="w-5 h-5 text-gray-400" data-id="element-234" />
                </button>
              </div>

              <div className="px-6 py-8 overflow-y-auto max-h-[calc(85vh-80px)] text-gray-300 space-y-6" data-id="element-235">
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-236">
                  Términos y Condiciones de Uso Tarjeta ELITE CREATOR PASS
                </h3>

                <section data-id="element-237">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-238">
                    1. NATURALEZA DEL PROGRAMA
                  </h3>
                  <p className="leading-relaxed" data-id="element-239">
                    El presente documento establece los términos y condiciones
                    aplicables al uso de la tarjeta de fidelización gratuita
                    denominada Elite Creator Pass (en adelante, "la Tarjeta"),
                    la cual permite a sus titulares acceder a beneficios,
                    descuentos y promociones ofrecidos por comercios afiliados
                    al programa.
                  </p>
                </section>

                <section data-id="element-240">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-241">
                    2. ACCESO A LA TARJETA
                  </h3>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-242">
                    <li data-id="element-243">
                      La Tarjeta es gratuita y de uso personal e intransferible.
                    </li>
                    <li data-id="element-244">
                      Podrá acceder a ella cualquier persona natural mayor de
                      edad que complete el formulario de afiliación
                      correspondiente y califique para alguna de las categorías
                      del programa.
                    </li>
                    <li data-id="element-245">
                      El uso de la Tarjeta implica la aceptación plena de estos
                      términos y condiciones.
                    </li>
                  </ul>
                </section>

                <section data-id="element-246">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-247">
                    3. BENEFICIOS Y PROMOCIONES
                  </h3>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-248">
                    <li data-id="element-249">
                      Los beneficios ofrecidos pueden incluir: descuentos
                      directos, promociones especiales, servicios
                      preferenciales, accesos exclusivos, invitaciones a
                      eventos, obsequios u otros incentivos, según lo determine
                      cada comercio afiliado.
                    </li>
                    <li data-id="element-250">
                      Cada comercio es el único responsable de aplicar,
                      mantener, modificar o cancelar los beneficios que ofrece a
                      los usuarios de la Tarjeta.
                    </li>
                    <li data-id="element-251">
                      Los beneficios están sujetos a condiciones particulares
                      propias de cada comercio (vigencia, stock, montos mínimos
                      de compra, restricciones, etc.).
                    </li>
                    <li data-id="element-252">
                      Los beneficios podrán variar dependiendo de la categoría
                      de la tarjeta, lo que será definido por quienes los
                      otorguen.
                    </li>
                  </ul>
                </section>

                <section data-id="element-253">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-254">
                    4. RESPONSABILIDAD DEL PROGRAMA
                  </h3>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-255">
                    <li data-id="element-256">
                      TicketMaestro y su Plataforma Benefika, empresa
                      procesadora de La Tarjeta, actúa únicamente como
                      intermediario que conecta a los usuarios con comercios y
                      empresas aliadas, sin asumir responsabilidad por la
                      calidad, disponibilidad o condiciones de los productos o
                      servicios ofrecidos.
                    </li>
                    <li data-id="element-257">
                      En caso de cualquier inconveniente o reclamo relacionado
                      con los beneficios, el usuario deberá comunicarse
                      directamente con el comercio o empresa correspondiente.
                    </li>
                  </ul>
                </section>

                <section data-id="element-258">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-259">
                    5. CATEGORÍAS DEL PROGRAMA
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-260">
                    El programa contempla 4 categorías de tarjeta, que se basan
                    en los siguientes criterios:
                  </p>
                  <div className="space-y-4 ml-4" data-id="element-261">
                    <div data-id="element-262">
                      <p className="font-semibold text-white mb-1" data-id="element-263">
                        Categoría 1 Estrella:
                      </p>
                      <p className="text-gray-400" data-id="element-264">
                        Creadores con un mínimo de 5.000 seguidores en Instagram
                        o TikTok y un máximo de 9.999.
                      </p>
                    </div>
                    <div data-id="element-265">
                      <p className="font-semibold text-white mb-1" data-id="element-266">
                        Categoría 2 Estrellas:
                      </p>
                      <p className="text-gray-400" data-id="element-267">
                        Creadores con un mínimo de 10.000 seguidores en
                        Instagram o TikTok y un máximo de 99.999.
                      </p>
                    </div>
                    <div data-id="element-268">
                      <p className="font-semibold text-white mb-1" data-id="element-269">
                        Categoría 3 Estrellas:
                      </p>
                      <p className="text-gray-400" data-id="element-270">
                        Creadores con un mínimo de 100.000 seguidores en
                        Instagram o TikTok y un máximo de 999.999.
                      </p>
                    </div>
                    <div data-id="element-271">
                      <p className="font-semibold text-white mb-1" data-id="element-272">
                        Categoría 4 Estrellas:
                      </p>
                      <p className="text-gray-400" data-id="element-273">
                        Creadores con un mínimo de 1.000.000 seguidores en
                        Instagram o TikTok.
                      </p>
                    </div>
                  </div>
                </section>

                <section data-id="element-274">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-275">
                    6. VIGENCIA Y MODIFICACIONES
                  </h3>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-276">
                    <li data-id="element-277">
                      La vigencia de la Tarjeta es indefinida, salvo que el
                      usuario o la organización emiten renuncien expresamente a
                      su uso. Sin embargo, la vigencia caducará en forma
                      automática en el caso que el usuario deje de pertenecer a
                      alguna de las categorías del programa.
                    </li>
                    <li data-id="element-278">
                      La organización se reserva el derecho de modificar,
                      suspender o cancelar el programa o sus términos y
                      condiciones, informando oportunamente a los usuarios a
                      través de sus canales oficiales.
                    </li>
                  </ul>
                </section>

                <section data-id="element-279">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-280">
                    7. PROTECCIÓN DE DATOS PERSONALES
                  </h3>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-281">
                    <li data-id="element-282">
                      Al afiliarse, el usuario autoriza el tratamiento de sus
                      datos personales conforme a la legislación vigente,
                      exclusivamente para fines informativos y promocionales
                      relacionados con el programa.
                    </li>
                    <li data-id="element-283">
                      Los datos no serán compartidos con terceros sin
                      consentimiento del titular, salvo requerimiento legal.
                      Puede ver más detalles en el documento de nuestras
                      Políticas de Privacidad y Protección de Datos Personales.
                    </li>
                  </ul>
                </section>

                <section data-id="element-284">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-285">
                    8. USO INDEBIDO Y CANCELACIÓN
                  </h3>
                  <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-286">
                    <li data-id="element-287">
                      El uso fraudulento, indebido o contrario a estos términos
                      puede dar lugar a la anulación inmediata de la Tarjeta y
                      la pérdida de sus beneficios.
                    </li>
                    <li data-id="element-288">
                      La organización podrá retirar o suspender la tarjeta en
                      caso de mal uso sin necesidad de notificación previa.
                    </li>
                  </ul>
                </section>

                <section data-id="element-289">
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-290">
                    9. VIGENCIA
                  </h3>
                  <p className="leading-relaxed" data-id="element-291">
                    La vigencia de estos Términos y Condiciones de Uso es desde
                    el 12 de septiembre de 2025 y permanecerá vigente hasta que
                    exista una nueva versión que la reemplace.
                  </p>
                </section>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}